<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<ng-container
  *ngIf="{
    showAddToCart: showAddToCart$ | async,
    showRequestaQuote$: showRequestaQuote$ | async,
    product: product$ | async,
    isLoading: isLoading$ | async,
  } as content"
>
  @if (!content.isLoading) {
    @if (content.showAddToCart) {
      <form [formGroup]="addToCartForm" (submit)="addToCart()">
        <div class="quantity" *ngIf="showQuantity">
          <label>{{ 'cart.addToCart.quantity' | cxTranslate }}</label>
          <div class="cx-counter-stock">
            <cx-item-counter [max]="maxQuantity" [control]="convertToUntypedFormControl(addToCartForm.get('quantity'))!"></cx-item-counter>

            <!-- <span class="info">
                        <span *ngIf="showInventory$ | async">{{ getInventory() }}</span> {{ hasStock ? ('addToCart.inStock' | cxTranslate) : ('addToCart.outOfStock' | cxTranslate) }}
                    </span> -->
          </div>
        </div>

        <ng-container *ngIf="hasStock">
          <ng-template [cxOutlet]="CartOutlets.ADD_TO_CART_PICKUP_OPTION" [(cxComponentRef)]="pickupOptionCompRef"></ng-template>
        </ng-container>

        <button
          class="btn-add-to-cart"
          [ngClass]="options?.displayAddToCart ? 'btn btn-outline-primary' : 'btn btn-primary btn-block'"
          type="submit"
          [disabled]="quantity <= 0 || quantity > maxQuantity"
        >
          <span class="icon d-flex material-symbols-outlined m-r-4"> shopping_cart </span>

          <span
            attr.aria-label="{{ options?.addToCartString ?? ('cart.addToCart.addToCart' | cxTranslate) }}"
            [ngClass]="options?.addToCartString === ('cart.addToCart.buyItAgain' | cxTranslate) ? 'buyItAgainLink' : ''"
          >
            {{ options?.addToCartString ?? ('cart.addToCart.addToCart' | cxTranslate) }}
          </span>
        </button>
      </form>
    } @else {
      @if (content.showRequestaQuote$) {
        <a
          [routerLink]="['/quotes']"
          [queryParams]="{ partNumber: content.product?.partNumber }"
          class="btn btn-primary w-100 text-transform-none"
        >
          <span class="material-symbols-outlined d-flex m-r-4"> request_quote </span>
          {{ 'cart.addToCart.priceZeroExceptionRequestQuote' | cxTranslate }}
        </a>
      }
    }
  } @else {
    <local-loader></local-loader>
  }
</ng-container>
